import React from "react";
import "../../css/deals/dealsfilter.css"

export default function DealFilters({ filters, setFilters }) {
  const handleChange = (e) => {
    setFilters({
      ...filters,
      stage: e.target.value,
    });
  };

  return (
    <div className="deal-filters">
      <select
        className="deal-filter-select"
        value={filters.stage}
        onChange={handleChange}
      >
        <option value="">All Stages</option>
        <option value="negotiation">Negotiation</option>
        <option value="documentation">Documentation</option>
        <option value="payment_pending">Payment Pending</option>
        <option value="closed_won">Closed Won</option>
        <option value="closed_lost">Closed Lost</option>
      </select>
    </div>
  );
}